import React from "react";
import classNames from "classnames";

import { Arrow } from "./arrow";
import { Props } from "./types";
import styles from "./styles.scss";

function NumberInput({ nbr, isDisabled = false, edit, submit }: Props) {
  const ref = React.useRef<HTMLInputElement | null>(null);
  const [isFocused, setIsFocused] = React.useState(false);
  const [isTimerStarted, setIsTimerStarted] = React.useState(false);
  const isValid = (nbr: number) => nbr >= 0;

  React.useEffect(() => {
    if (ref.current && !isNaN(nbr) && !isFocused) {
      ref.current.value = (Math.round(nbr * 100) / 100).toString();
    }
  }, [nbr, ref.current, isFocused]);

  React.useEffect(() => {
    let timer: number;

    if (isTimerStarted) {
      timer = window.setTimeout(() => {
        submit(nbr);
        setIsTimerStarted(false);
      }, 500);
    }

    return () => {
      timer && window.clearTimeout(timer);
    };
  }, [isTimerStarted, nbr]);

  return (
    <form
      className={classNames(styles.numberInput, {
        [styles.disabled]: isDisabled,
      })}
      noValidate
      onSubmit={(e) => {
        e.preventDefault();

        if (!isDisabled) {
          const nextNbr = isNaN(nbr) ? 0 : nbr;

          isValid(nextNbr) && submit(nextNbr);
        }
      }}
    >
      <div className={styles.main}>
        <input
          ref={ref}
          type={isFocused ? "number" : "text"}
          min={0}
          className={styles.input}
          disabled={isDisabled}
          onFocus={() => {
            setIsFocused(true);
            if (ref.current && (nbr === 0 || isNaN(nbr))) {
              ref.current.value = "";
            }
          }}
          onChange={({ target }) =>
            edit(
              parseFloat(
                parseFloat(target.value)
                  .toFixed(2)
                  .replace(/0+$/, "")
                  .replace(/\.$/, ""),
              ),
            )
          }
          onBlur={() => {
            setIsFocused(false);
            const nextNbr = isNaN(nbr) ? 0 : nbr;
            return !isDisabled && isValid(nextNbr) && submit(nextNbr);
          }}
        />
        <div className={styles.arrows}>
          <div
            className={styles.iconBox}
            onClick={() => {
              if (!isDisabled && isValid(nbr + 1)) {
                edit(nbr + 1);
                setIsTimerStarted(true);
              }
            }}
          >
            <Arrow className={styles.icon} />
          </div>
          <div
            className={styles.iconBox}
            onClick={() => {
              if (!isDisabled && isValid(nbr - 1)) {
                edit(nbr - 1);
                setIsTimerStarted(true);
              }
            }}
          >
            <Arrow className={styles.icon} />
          </div>
        </div>
      </div>
    </form>
  );
}

export { NumberInput };
